import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { CommonEntityService } from '../../../services/common-entity.service';

@Component({
  selector: 'app-autocomplete-cell-editor',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.sass']
})
export class AutocompleteEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  @ViewChild('autocompleteComponent') autoComplete: AutoComplete;
  @ViewChild('editorContainer') editorContainer: ElementRef;

  private params: any;
  public value: any[] | null = [];
  public originalValue: any[] | null = [];
  public fieldName: string = '';
  public options: any[] = [];
  public suggestions: any[] = [];
  public optionLabel: string = 'name';
  public optionValue: string = '_id';
  public entityApiPath: string = '';
  public isMultiple: boolean = true;
  public baseQuery: any = {};

  constructor(private commonEntityService: CommonEntityService) { }

  agInit(params: any): void {
    this.params = params;

    this.fieldName = this.params.colDef.headerName;

    this.entityApiPath = this.params.colDef.filterParams?.populate ?
      this.params.colDef.filterParams?.entity || 'items' : 'items';

    if (this.params.optionLabel) {
      this.optionLabel = this.params.optionLabel;
    }

    if (this.params.optionValue) {
      this.optionValue = this.params.optionValue;
    }

    if (this.params.baseQuery) {
      this.baseQuery = this.params.baseQuery;
    }

    this.isMultiple = this.params.colDef.cellRendererParams?.isArray !== false;

    if (this.params.value) {
      if (this.isMultiple) {
        this.value = Array.isArray(this.params.value) ? [...this.params.value] : [this.params.value];
        this.originalValue = [...this.value];
      } else {
        this.value = this.params.value;
        this.originalValue = this.params.value;
      }
    } else {
      this.value = this.isMultiple ? [] : null;
      this.originalValue = this.isMultiple ? [] : null;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.autoComplete) {
        this.autoComplete.inputEL?.nativeElement.focus();
        this.autoComplete.el.nativeElement.addEventListener('keydown', this.handleKeyDown.bind(this), true);
      }
    }, 0);
  }

  search(event: any) {
    const query = event.query;
    
    if (query && query.length >= 1) {
      let queryObj: any;
      
      const isNumeric = /^\d+$/.test(query);
      
      if (isNumeric) {
        queryObj = {
          ...this.baseQuery,
          $or: [
            { id: parseInt(query) },
            { name: { $regex: query, $options: 'i' } }
          ]
        };
      } else {
        queryObj = { ...this.baseQuery, name: { $regex: query, $options: 'i' } };
      }

      this.commonEntityService.findAllWithQuery(this.entityApiPath, {
        query: queryObj,
        select: this.params.colDef.filterParams?.select || '_id id name',
        virtuals: true,
        autopopulate: true,
        sort: { name: 1 },
        isOptions: true,
        limit: 30
      }).then(results => {
        if (isNumeric) {
          const idString = query;
          this.suggestions = results.filter((item: any) => {
            const itemIdString = item.id.toString();
            return itemIdString === idString || itemIdString.startsWith(idString);
          });
        } else {
          this.suggestions = results;
        }
      }).catch(error => {
        this.suggestions = [];
      });
    } else {
      this.suggestions = [];
    }
  }

  getValue(): any {
    return this.value;
  }

  isPopup(): boolean {
    return true;
  }

  clearValue() {
    this.value = this.isMultiple ? [] : null;
  }

  setOriginalValue() {
    this.value = this.originalValue;
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (this.autoComplete) {
        this.autoComplete.hide();
      }
    }
  }
} 